<template>
  <div id="app">
    <!-- <div class="container">
      <div class="container">
        <VueSignaturePad
          id="signature"
          width="100%"
          height="500px"
          ref="signaturePad"
          :options="options"
        />
      </div>
      <div class="buttons">
        <button @click="undo">Effacer</button>
        <button @click="save">J'accepte les termes du contrat</button>
      </div>
    </div> -->

    <div class="form-popup">
      <div class="form-container">
        <header>
          <div class="header-part">
            <span>
              Création du contrat de bail
            </span>
            <i class="ik ik-x clos"></i>
          </div>
          <div class="progress-area">
            <div class="step-item">
              <span :class="{'active': step == 0}">
                Habitation
              </span>
              <div class="bullet" :class="{'active': step == 0}">
                <span v-show="step == 0">1</span>
                <div  v-show="step > 0">
                  <i class="ik ik-check"></i>
                </div>
              </div>
            </div>
            <div class="step-item">
              <span :class="{'active': step == 1}">
                Facturation
              </span>
              <div class="bullet" :class="{'active': step == 1}">
                <span v-show="step <= 1">2</span>
                <div  v-show="step > 1">
                  <i class="ik ik-check"></i>
                </div>
              </div>
            </div>
            <div class="step-item">
              <span :class="{'active': step == 2}">
                Contrat
              </span>
              <div class="bullet" :class="{'active': step == 2}">
                <span v-show="step <= 2">3</span>
                <div v-show="step > 2">
                  <i class="ik ik-check"></i>
                </div>
              </div>
            </div>
            <div class="step-item">
              <span :class="{'active': step == 3}">
                Pièces jointes
              </span>
              <div class="bullet" :class="{'active': step == 3}">
                <span v-show="step <= 3">4</span>
                <div v-show="step > 3">
                  <i class="ik ik-check"></i>
                </div>
              </div>
            </div>
            <div class="step-item">
              <span :class="{'active': step == 4}">
                Visualisation
              </span>
              <div class="bullet" :class="{'active': step == 4}">
                <span>5</span>
              </div>
            </div>
          </div>
        </header>
        <div class="main-form">
          <div v-show="step == 0" class="process-item habitation">
            <div class="concern-log">
              <div class="concern-log-select">
                <span class="title">Lorem, ipsum dolor.</span>
                <input type="text" placeholder="selectionner le logement concerné">
              </div>
              <div class="concern-log-view">
                <span class="title">Visualisation du logement selectionné</span>
                <div class="concern-log-view-img">
                  <img src="" alt="">
                </div>
              </div>
            </div>
            <div class="concern-hbt">
              <div class="concern-hbt-select">
                <span class="title">Lorem, ipsum dolor.</span>
                <input type="text" placeholder="selectionner l'habitant concerné">
                <!-- <v-select :options="logements" v-model="occupation.idLogement" :reduce="logement => logement.idLogement" label="refLogement"  @input="setSlide_logement">
                    <template #option="{ refLogement, sousTypeLogement, prixMin, prixMax}">
                        <b>{{ refLogement }}</b><br />
                        <span>{{ sousTypeLogement.libelleSousType }}</span>
                                             | 
                        <span class="text-muted">
                            {{ prixMin | currency('F' || '', 0,{  symbolOnLeft: false, spaceBetweenAmountAndSymbol: true, thousandsSeparator: ' '  }) }}
                            - 
                            {{ prixMax | currency('F' || '', 0,{  symbolOnLeft: false, spaceBetweenAmountAndSymbol: true, thousandsSeparator: ' '  }) }}
                        </span>
                    </template>
                </v-select> -->
              </div>
              <div class="concern-hbt-view">
                <span class="title">Visualisation de l'habitant selectionné</span>
                <div class="concern-hbt-block">
                  <div class="avatar">
                    <img src="" alt="">
                  </div>
                  <div class="hbt-txt">
                    <span>Belinga Paul Martin</span>
                    <span>+237 657 89 64 72</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="step == 1" class="process-item facturation">
            <div class="facturation-item">
              <span class="title">
                Infos concernant le logement
              </span>
              <div class="input-container">
                <input type="number" required placeholder="Loyer par mois">
                <input type="number" required placeholder="Combien de mois le locataire a t-il avancé">
                <input type="number" required placeholder="somme versée faisant office de caution">
                <input type="number" required placeholder="Date debut du bail">
              </div>
            </div>
            <div class="facturation-item">
              <span class="title">
                Mode de paiement
              </span>
              <div class="input-container radio">
                <label :class="{'check':payment == 'Post-payé'}">
                  <input type="radio" :value="paymentMode[0]" v-model="payment">
                  <span>Post-payé</span>
                </label>
                <label :class="{'check':payment == 'Pre-payé'}">
                  <input type="radio" :value="paymentMode[1]" v-model="payment">
                  <span>Prépayé</span>
                </label>
              </div>
            </div>
            <div class="facturation-item">
              <div class="input-container">
                <div class="index-water">
                  <span class="title">Facturation d'eau</span>
                  <div class="input-container index">
                    <label :class="{'check':indexWaterMode == 'forfait'}">
                      <input type="radio" value="forfait" v-model="indexWaterMode">
                      <span>Paiement par forfait</span>
                    </label>
                    <label :class="{'check':indexWaterMode == 'index'}">
                      <input type="radio" value="index" v-model="indexWaterMode">
                      <span>Paiement par indexe</span>
                    </label>
                  </div>
                  <div class="input-container" v-show="indexWaterMode == 'forfait'">
                    <input type="number" style="width:100%" placeholder="Entrez le taux forfaitaire">
                  </div>
                  <div class="input-container" v-show="indexWaterMode == 'index'">
                    <input type="number" placeholder="Prix unitaire par indexe">
                    <input type="number" placeholder="Indexe initial">
                  </div>
                </div>
                <div class="barre" style="height:80%;width:1px;background:#eee;"></div>
                <div class="index-water">
                  <span class="title">Facturation électricité</span>
                  <div class="input-container index">
                    <label :class="{'check':indexElecMode == 'forfait'}">
                      <input type="radio" value="forfait" v-model="indexElecMode">
                      <span>Paiement par forfait</span>
                    </label>
                    <label :class="{'check':indexElecMode == 'index'}">
                      <input type="radio" value="index" v-model="indexElecMode">
                      <span>Paiement par indexe</span>
                    </label>
                  </div>
                  <div class="input-container" v-show="indexElecMode == 'forfait'">
                    <input type="number" style="width:100%" placeholder="Entrez le taux forfaitaire">
                  </div>
                  <div class="input-container" v-show="indexElecMode == 'index'">
                    <input type="number" placeholder="Prix unitaire par indexe">
                    <input type="number" placeholder="Indexe initial">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="step == 2" class="process-item contrat">
            <div class="contrat-templates">
              <span class="title">Modèles de contrat prédefinis</span>
              <div class="contrat-container">
                <div class="contrat-item">
                  <div class="contrat-icon">
                    <i class="ik ik-file-text"></i>
                  </div>
                  <span>Lorem, ipsum dolor</span>
                </div>
                <div class="contrat-item">
                  <div class="contrat-icon">
                    <i class="ik ik-file-text"></i>
                  </div>
                  <span>Lorem, ipsum dolor</span>
                </div>
                <div class="contrat-item">
                  <div class="contrat-icon">
                    <i class="ik ik-file-text"></i>
                  </div>
                  <span>Lorem, ipsum dolor</span>
                </div>
              </div>  
            </div>
            <vue-editor v-model="content" class="editor"></vue-editor>
          </div>
          <div v-show="step == 3" class="process-item join">
            <span class="title">
              Ajoutez des pièces
            </span>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi, enim provident pariatur.
            </p>
            <div class="upload-container">
              <label>
                <input type="file">
                <i class="fas fa-upload fa-2x"> </i>
                <span class="title">
                  Etats des lieux d'entrée
                </span>
              </label>
              <label>
                <input type="file">
                <i class="fas fa-upload fa-2x"> </i>
                <span class="title">
                  Protocole d'accord
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="form-footer">
          <button class="prev-btn" v-show="step !== 2" @click="step--">Précédent</button>
          <button v-show="step == 2" @click="step++"> <i class="ik ik-slack" style="margin-right:5px;"></i> Signer le document</button>
          <button class="next-btn" v-show="step !== 2" @click="step++">Suivant</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import DatePicker from 'vue2-datepicker';
export default {
    components: {
        DatePicker,
        VueEditor
    },
  name: "App",
  data: () => ({
    options: {
      penColor: "#000",
    },
    paymentMode:['Post-payé','Pre-payé'],
    indexWaterMode:'',
    indexElecMode:'',
    payment:'',
    step:0,
    content:"<h1 class=\"ql-align-center\"><strong>CONTRAT DE BAIL A USAGE D'HABITATION </strong></h1><p><br></p><p><br></p><h3>	<strong>DESIGNATION DES PARTIES</strong></h3><p><br></p><h3>	<strong><u>LE COMPLEXE INDUSTRIEL DU CAMEROUN en abrégé ( CIC )</u></strong></h3><p>	</p><p>	 siège : <strong>.{{ LOGEMENT_ADRESSE_PAYS}}</strong></p><p>	</p><p>	Représenté par : <strong>.{{  NOM_BAILLEUR }}</strong></p><p>  </p><p>    N° de CNI : <strong>{{  CNI_BAILLEUR }}</strong></p><p><br></p><p>	Date de Délivrance : ....................</p><p><br></p><p>    Tél : <strong>{{  TEL_BAILLEUR }}</strong></p><p><br></p><p>                ci-après désigné  <strong>&lt;&lt; BAILLEUR &gt;&gt;</strong></p><p><br></p><p>																								<strong>ET</strong></p><p><br></p><h3>		</h3><h3>		<strong><u>Le LOCATAIRE</u></strong></h3><p>		</p><p>			 NOM:<strong> {{ LOCATAIRE_NOMS_PRENOMS }}</strong></p><p>	</p><p>			Né 	le : <strong>{{ LOCATAIRE_DATE_NAISSANCE  }}</strong></p><p>  </p><p>  		    Fils de  : ............</p><p><br></p><p>	        Exercant  de: ........</p><p><br></p><p>            N° de CNI: <strong>{{ LOCATAIRE_CNI }}</strong></p><p>		</p><p>			Date de délivrance: .................</p><p><br></p><p>			Tel: <strong>{{ LOCATAIRE_TEL  }}</strong></p><p><br></p><p><strong>carte nationale d'identité :</strong></p><p><img src=\"{{ CNI_AVANT }}\">  <img src=\"{{ CNI_ARRIERE }}\"></p><br><p>ci-après désigné  &lt;&lt; LE PRENEUR&gt;&gt;</p><p><br></p><h2>	</h2><h3>				<strong>IL A ETE ARRETE ET CONVENU CE QUI SUIT</strong></h3><p><br></p><p><br></p><h3>	<strong>Article 1: OBJET-USAGE DES LIEUX</strong></h3><p>	</p><p>	1.1 Le bailleur loue par les présentes au preneur qui accepte les lieux ci-après décrits à l'article 2, situé au quartier Mvan à usage exclusif d'habitation.</p><p><br></p><p>	1.2 Ils ne pourront être utilisé même temporairement à d'autres usages que celui ainsi arrêté sous</p><p>			peine de résiliation de plein droit de bail, suivi d'un délaissement immédiat à la première demande du bailleur&nbsp;.</p><p><br></p><p><br></p><h3>	<strong>Article 2: DESIGNATION-COMPOSITION-ETAT DES LIEUX</strong></h3><p><br></p><p>	2.1 Les locaux objet du présent bail se présentent ainsi qu'il suit :</p><ul><li>		<strong>{{ CARACTERISTIQUES_LOGEMENT }}</strong></li></ul><p><br></p><p>   2.2 Il n'est pas fait plus ample description des lieux loués, le preneur déclarant les connaitre parfaitement pour les avoir vu, visité, et accepté  tels quels avant conclusion du présent contrat</p><p><br></p><p>	2.2 A défaut des lieux ci-dessus, le preneur reconnait  qu'il sera réputé avoir occupé les lieux en parfait état.</p><p><br></p><h3><strong>Article 3: DUREE DU BAIL-AVENANT DE RENOUVELEMENT</strong></h3><p><br></p><p>	3.1 Le présent bail est inclus pour une durée ferme et définitive <strong>{{ CONTRAT_DUREE }}</strong> mois ? Sauf si les parties en disposent autrement</p><p><br></p><p>	3.2 Un mois avant la fin du bail , il est inclus un nouveau bail si nécessaire pour la même durée à la même demande écrite du locataire.</p><p><br></p><p>	3.3 En cas d'acceptation du bailleur ou de son silence garder jusqu'au moins deux semaines avant l'expiration du bail, le renouvellement est acquis et dans tous les cas pour une durée supplémentaire d'un an.</p><p><br></p><h3><strong>Article 4: PRIX DU LOYER ET DES REDEVANCES D'OCCUPATION</strong></h3><p><br></p><p>	 4.1 Le prix du loyer mensuel hors taxes consenti pour la présente location est de : <strong>{{ PRIX_LOYER }} FCFA</strong></p><p>	</p><p>    4.2 Que le preneur accepte payer ainsi que les accessoires, à chaque échéance ci-après indiquée ;</p><p><br></p><p>	4.3 Le loyer est payable mensuellement ;</p><p><br></p><p>	4.4 Le preneur s'oblige à s'acquitter ses loyers et accessoires par terme et d'avance à Yaoundé, au plus tard le premier jour de chaque mois ;</p><p><br></p><p>	4.5 Les paiements tant du loyer que de accessoires seront effectuées par des versements en espèces entre les mains du bailleur ou de tout autre mandataire détenteur d'une bonne et valable procuration ;</p><p><br></p><p><br></p><h3><strong>Article 5: FRAIS D'ETABLISSEMENT, DEPENSES D'ENREGISTREMENT, TIMBRE DE TAXES DIVERSES, ET FRAIS DE POURSUITES </strong></h3><p><br></p><p>5.1 Tous les frais fixés par les règlements publics relatifs à l'établissement de présentes ( frais d'enregistrement, frais de timbre et pénalités de toutes natures), sont   à la charge du preneur;</p><p><br></p><p>5.2 Les taxes fixées par les administrations publiques, communales sont également à sa charge et dues dans les conditions et aux dates fixées par ces administrations ; il devra justifier de leurs acquis avant de déménager ;</p><p><br></p><p>5.3 En cas de règlement tardif de ces taxes par le preneur, les pénalités administratives et fiscales en résultant sont à la charge du preneur;</p><p><br></p><p>5.4 Les frais droits et honoraires auxquels pourront donner lieu le présent acte et ses suites, y compris les frais de poursuites de  toutes natures, seront supportés par le preneur;</p><p><br></p><h3><strong>Article 6: LA CAUTION OU DEPOT DE GARANTIE</strong></h3><p><br></p><p>6.1 Le montant de la caution ou du dépôt de garantie est de : <strong>{{ MONTANT_CAUTION }} FCFA</strong></p><p><br></p><p>6.2 Le preneur a versé la somme de <strong>{{ AVANCE }} FCFA</strong> correspondant à une avance de <strong>{{ NBRE_MOIS }}</strong> mois de loyer.</p><p><br></p><p>6.3 Le dernier terme du loyer ne sera ni imputable sur le dépôt de garantie ; Celui-ci restera conservé à titre de sûreté de bonne exécution du présent bail;</p><p><br></p><p>6.4 Le preneur ne pourra exiger le remboursement de la caution ou du dépôt de garantie en fin de jouissance, dès complet déménagement,  remise de toutes les clés et des lieux en état initial d'occupation ; </p><p><br></p><h3><strong>Article 7: ENTRETIEN TRAVAUX REPARATIONS-REGLEMENTS D'IMMEUBLE</strong></h3><p><br></p><p>7.1 Le preneur entretiendra les lieux loués en bon état de réparation locative, en jouira en bon père de famille et les restituera en fin de bail en bon état.</p><p><br></p><p>7.2 Le preneur devra notamment refaire les badigeons, peinture de boiserie, des murs, portes, plafonnage, etc... conformément aux dispositions de l'article 1 754 code civil aussi souvent que besoin sera ;</p><p><br></p><p>7.3 Le bailleur ne sera tenu d'exécuter au cours du bail que les grosses réparations qui pourraient, conformément aux disposition de l'article 1 720 du code civil, devenir nécessaires, toute autre réparation quelle qu'elle soit restant à chaque charge du preneur qui en supportera les conséquences.</p><p><br></p><h3><strong>Article 8: CESSION DE BAIL SOUS LOCATION</strong></h3><p><br></p><p>8.1 Le présent bail est signé intuitu personnage, toute cession des droits au présent contrat, toute sous location est interdite ;</p><p><br></p><h3><strong>Article 9: REGLEMENT URBAIN</strong></h3><p><br></p><p>9.1 Le preneur satisfera à toutes les prescriptions de police, de voirie et d'hygiène ;</p><p><br></p><h3><strong>Article 10: ASSURANCES-RESPONSABILITES-RECOURS DIVERS</strong></h3><p><br></p><p>10.1 Le preneur est responsable de toutes dégradations commises, et de tous sinistres directs et indirects qui pourraient être survenus par lui, par les occupants de son chef, ou par des tiers quelconques se trouvant même momentanément sur les lieux loués par lui, ou ayant un rapport quelconque avec&nbsp;lui ;</p><p><br></p><p>10.2 Il sera particulièrement responsable et de plein droit, des dégâts causés en cours d'aménagement, ainsi que ceux résultant des activités des personnes effectuant pour son compte des travaux sur les lieux, ou celle des personnes vivants avec lui ;</p><p><br></p><p>10.3 Il renonce à tous recours en responsabilité contre le bailleur, et pourra exiger de ce dernier aucune indemnité, ni diminution de loyer dans les cas ci-après en cas d'interruption dans le service de l'eau, d'électricité, par suite d'accident ou d’événements indépendants de la volonté du bailleur ;</p><p><br></p><p><br></p><h3><strong>Article 11: VISITES-ACCES DES LIEUX-REMISE DES CLES</strong></h3><p><br></p><p>11.1 Le preneur après avoir été au moins vingt quatre (24) heures à l'avance, devra laissé le bailleur ( en personne ou celle de son représentant préposé ) visité les lieux loués chaque fois qu'il le jurera nécessaire, pour tous travaux, relevés, et inspections utiles;</p><p><br></p><p>11.2 Il devra également laisser pénétré les architectures ou entrepreneurs et leur personnel pour tous travaux rendus nécessaires ;</p><p><br></p><p><br></p><h3><strong>Article 12: ELECTRICITE-EAU-TELEPHONE-IMAGETV-INTERNET</strong></h3><p><br></p><p>12.1 Le preneur paiera directement au concessionnaire le montant des abonnement ou consommation d'eau, d'électricité, de téléphone, d'image TV et Internet ; il fera son affaire personnelle;</p><p><br></p><p>12.2 Consommation en eau:&nbsp;&nbsp;Le preneur s'engage à payer la somme de <strong> {{ FORFAIT_EAU }} FCFA </strong> par mois représentant le montant du forfait convenu.</p><p class=\"index_eau\">12.2 Consommation en eau:&nbsp;La consommation en eau du preneur sera calculée chaque mois sur la base des indexes qui seront relevés sur son compteur avec une facturation de <strong> {{ PU_EAU }} le KWh </strong>. A son entrée, l'index relevé est de <strong> {{ INDEX_EAU }}.</strong></p><p>12.3 Consommation en électricité:&nbsp;&nbsp;Le preneur s'engage à payer la somme de <strong>{{ FORFAIT_ELECTRICITE }} FCFA</strong> par mois représentant le montant du forfait convenu.</p><p class=\"index_electricite\">12.3 Consommation en électricité:&nbsp;La consommation en électricité du preneur sera calculée chaque mois sur la base des indexes qui seront relevés sur son compteur électrique avec une facturation de<strong> {{ PU_ELECTRICITE }} le KWh </strong> . A son entrée, l'index relevé est de <strong>{{ INDEX_ELECTRICITE }} . </strong></p><p><br></p><p><br></p><h3><strong>Article 13: TOLERENCES</strong></h3><p><br></p><p>13.1 Toutes tolérances de la part du bailleur, quelles qu'en aient pu être la fréquence et la durée au sujet des clause et conditions du présent accord, ne pourront jamais être considérés comme apportant des modifications ou suppressions de ces clauses et conditions, ni comme génératrice d'un droit quelconque ;</p><p><br></p><h3><strong>Article 14: CLAUSE RESOLUTOIRE - PRIVILEGE DU BAILLEUR</strong></h3><p><br></p><p>14.1 Les parties conviennent expressément que le présent bail sera considéré comme résilié de plein droit et le contrat éteint définitivement pour l'avenir, sans aucune formalité, entre elles dans les hypothèses ci-après :</p><p><br></p><p>&nbsp;&nbsp;&nbsp;a-) En cas du décès du preneur ,</p><p><br></p><p>	 b-) En&nbsp;cas de non paiement à son écheance&nbsp;d'un seul terme de loyer, ou d'une quelconque somme due en vertu des présentes et huit jours après sommation de payer restée infructueuse ;</p><p><br></p><p><br></p><p>14.2 Dans tous les cas de résiliation, sans préjudice des autres voies de droit, le mobilier garnissant les lieux loués, pourra au gré du bailleur, être séquestré sur place ou dans un garde meuble, aux frais, risque et périls sur requête signés par Monsieur le Président du Tribunal de Première Instance de Yaoundé EKOUNOU, à charge de lui en référé en cas de difficultés ;</p><p><br></p><p>&nbsp;&nbsp;&nbsp;</p><p>14.3 Le séquestre du mobilier fait conformément à la clause ci-dessus pourra être levé, soit par accords amiable signés entre les parties, soit à la suite d'une procédure judiciaire définitive de liquidation de l'intégralité des droits du bailleur.</p><p><br></p><p><br></p><p>14.4 En cas de résiliation amiable, les parties acceptent organiser dans les accords écrits particuliers les modalités de liquidation des droits de chacune d'elles, celle-ci pouvant prévoir qu'il soit défalqué la caution ou du dépôt de garantie, indépendamment des loyers, arriérés de loyers et accessoires, les frais de remise des locaux en état, et plus généralement toute somme due,</p><p><br></p><p><br></p><p><br></p><h3><strong>Article 15: DELAISSEMENT FORCE DE L'IMMEUBLE OU EXPULSION</strong></h3><p><br></p><p>	15.1 Après extinction du présent bail, ou en cas d'acquisition définitive de la clause résolutoire, le délaissement forcé de l'immeuble sera poursuivi et exécuté suivant la simple procédure de référé engagé devant le Tribunal de Première Instance de Yaoundé Ekounou ;</p><h2><br></h2><h3><strong>Article 16: OCCUPATION DES LIEUX APRES CESSATION OU RESILIATION DU BAIL</strong></h3><p><br></p><p>	16.1 Au cas où après cessation ou résiliation du bail, et pour quelque cause que ce soient, les lieux ne seraient pas restitués en l'état au bailleur, et libre de toute occupation, il lui sera dû une indemnité contractuelle d'occupation ;</p><h2><br></h2><h3><strong>Article 17: ELECTION DE DOMICILE - ATTRIBUTION DE COMPETENCE</strong></h3><p><br></p><p>	17.1 Pour l'exécution des présentes, les parties font élection de domicile à leur adresse respective à Yaoundé</p><p><br></p><p>	17.2 A défaut d'accords écrit particuliers amiables terminant tout litige entre les parties en cours d'exécution du présent bail, le président du Tribunal de Première Instance de Yaoundé Ekounou ou tout juge délégué par lui, siègent en chambre de conseil, ou en matière d'urgence est la juridiction contractuelle unique pour trancher tout différend né entre les parties;</p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p>",

  }),
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      //   alert("Open DevTools see the save data.");
      console.log(isEmpty);
      console.log(data);
    },
  },
  mounted(){
  }
};
</script>

<style>
/*#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: "100%";
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
button {
  padding: 15px 25px;
  border: none;
}*/
*{
  box-sizing: border-box;
  font-size: 1rem;
}
.form-popup{
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
}
.form-popup .form-container{
  display: flex;
  flex-direction: column;
  height: 90%;
  width: 60%;
  background: white;
  border-radius: 8px;
}
.form-container header{
  padding: 0 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 160px;
  border-bottom: 1px solid #eee;
}
.form-container header .header-part{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
}
.header-part span{
  font-weight: bold;
  font-size: 1.5rem;
}
.header-part .clos{
  font-size: 1.8rem;
  color: #191c22;
  cursor: pointer;
}
header .progress-area{
  margin-top: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
}
.progress-area .step-item{
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width:auto;
  height: auto;
  user-select: none;
  cursor: pointer;
}
.step-item span{
  font-weight: 500;
  color: #424242;
}
.step-item span.active{
  color:#F5365C; 
}
.step-item .bullet{
  position: relative;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  border: 1px solid #424242;
  overflow: visible;
}
.step-item .bullet span{
  font-size: .9rem;
  font-weight: bold;
  text-align: center;
  color: #424242;
}
.step-item .bullet div{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  background: #424242;
}
.step-item .bullet div i{
  color: white;
  font-size: 1.2rem;
}
.bullet.active{
  border: 1px solid #F5365C;  
}
.bullet.active span{
  color:#F5365C;  
}
.step-item .step .bullet:before,
.step-item .step .bullet:after {
    position: absolute;
    content: "";
    bottom: 11px;
    right: -51px;
    height: 3px;
    width: 44px;
    background: #191c22;
}
.form-container .form-footer{
  padding: 0 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px;
  border-top: 1px solid #eee;
}
.form-footer button{
  padding: 0px 35px;
  height: 45px;
  border-radius: 4px;
  font-weight: bold;
  border: 1px solid #F5365C;
  color: white;
  background: #F5365C;
  transition: .3s ease all;
}
.form-footer button:nth-child(1){
  color: #F5365C;
  background: transparent;
}
.form-footer button:nth-child(2){
  color: white;
  background: #191c22;
  border-color: #191c22;
}
.form-container .main-form{
  display: flex;
  align-items: center;
  width: 100%;
  height: calc(100% - 240px);
}
.process-item{
  padding: 0 5%;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  transition: .3s ease all;
}
.process-item.habitation .concern-log{
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 48%;
  height: 100%;
}
.concern-log .concern-log-select,
.concern-hbt .concern-hbt-select{
  display: flex;
  flex-direction: column;
  width: 100%;
}
.concern-log-select span,
.concern-log-view span,
.concern-hbt-select span{
  font-size: 1rem;
  color: #424242;
}
.concern-log-select input,
.concern-hbt-select input{
  padding-left: 5px;
  margin-top: 10px;
  width: 80%;
  height: 45px;
  border: 1px solid #eee;
  outline: none;
  background: transparent;
  border-radius: 8px;
}
.concern-log-view{
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.concern-log-view .concern-log-view-img{
  margin-top: 20px;
  width: 80%;
  height: 180px;
  background: #ddd;
  border-radius: 8px;
}
.process-item.habitation .concern-hbt{
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 48%;
  height: 100%;
}
.concern-hbt-view {
  margin-top: 30px;
  width:100%;
  height: 180px;
}
.concern-hbt-view .concern-hbt-block{
  margin-top: 20px;
  display: flex;
  width: 100%;
  height: 180px;
}
.concern-hbt-block .avatar{
  height: 100%;
  width: 40%;
  border-radius: 8px;
  background: #eee;
}
.concern-hbt-block .avatar img{
  height: 100%;
  width: 100%;
  border-radius: 8px;
  object-fit: cover;
}
.concern-hbt-block .hbt-txt{
  padding-left: 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  height: 100%;
}
.concern-hbt-view span{
  margin-top: 10px;
  color: #424242;
}
.process-item.facturation{
  padding: 30px 5%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.facturation-item{
  margin-bottom: 30px;
}
.input-container{
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
}
.title{
  font-weight: 600;
}
.input-container input{
  padding: 0 5px;
  margin-bottom: 15px;
  height: 45px;
  width: 45%;
  border: 1px solid #eee;
  border-radius: 8px;
}
.input-container.radio label, 
.input-container.index label{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  width: 45%;
  background: transparent;
  background: #f0f0f0;
  border-radius: 8px;
}
.input-container.radio label.check,
.input-container.index label.check{
  background: #191c22;
  color: white;
}
.input-container.radio label input{
  display: none;
}
.input-container .index-water{
  display: flex;
  flex-direction: column;
  width: 48%;
  height: auto;
}
.input-container .index-water input[type="radio"]{
  display: none;
}
.process-item.contrat{
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  overflow-y: auto;
}
.process-item.contrat .contrat-templates{
  padding-top: 15px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 150px;
}
.contrat-templates .contrat-container{
  display: flex;
  justify-content: space-between;
  height: 60px;
  width: 100%;
}
.contrat-container .contrat-item{
  margin-right: 1%;
  display: flex;
  align-items: center;
  height: 60px;
  width: 31%;
  border-radius: 8px;
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.contrat-item .contrat-icon{
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 50px;
  font-size: 1.5rem;
}
.contrat-item span{
  font-weight: 500;
  font-size: 1rem;
}
.process-item.contrat .editor{
  margin-top: 30px;
  margin-right: 2%;
  height: auto;
  width: 98%;
}
.process-item.join{
  padding-top: 30px;
  flex-direction: column;
  justify-content: flex-start;
}
.process-item.join .title{
  margin-top: 10px;
}
.process-item.join .upload-container{
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.process-item.join p{
  margin-top: 10px;
}
.upload-container label{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #efefef;
  height:10rem;
  width: 46%;
  border-radius: 8px;
}
.upload-container label input{
  display: none;
}
.upload-container label i{
  margin-bottom: 15px;
  color: #424242;
}
</style>
